import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, submit, reset, Form, Field, formValueSelector, getFormValues } from 'redux-form';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PYMT_SECURITY_FORM_ID, FLOW_TYPE } from '../../../framework/App/AppConstants';
import AnnouncementPopup from '../../../shared-components/AnnouncementPopup/AnnouncementPopup';
import Button, { BUTTON_STYLE, BUTTON_TYPE } from '../../../shared-components/Button/Button';
import './PaymentSecurityPage.less';
import CheckBox, { CHECKBOX_LABEL_STYLE } from '../../../shared-components/CheckBox/CheckBox';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { submitPaymentSecurity } from './PaymentSecurityPageActions';
import { PYMT_SECURITY_CARD, PYMT_SECURITY_CTRL } from './PaymentSecurityPageConstants';
import { UmbrellaIllustration } from '../../components/PaymentSecurity/UmbrellaImage';
import RadioInput from './RadioInput';
import { push } from 'connected-react-router';
import { PAGE_NAME } from '../../config/pageNames';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import PaymentSecurityProgramAgreementModal, { PAYMENT_SECURITY_PROGRAM_AGREEMENT_URL } from './PaymentSecurityProgramAgreementModal';
import PaymentSecurityProgramAgreementContent from './PaymentSecurityProgramAgreementContent';
import CancelUrl, { COMPONENT_STYLE } from '../../components/CancelUrl/CancelUrl';


export const PURCHASE_PYMT_SECURITY = 'PURCHASE_PYMT_SECURITY';
export const DO_NOT_PURCHASE_PYMT_SECURITY = 'DO_NOT_PURCHASE_PYMT_SECURITY';
export const READ_PROGRAM_AGREEMENT_CHECKBOX_KEY = 'agreeToPymtSecurity';
export const PAYMENT_SECURITY_CHOICE_RADIO_KEY = 'pymtSecurityChoice';

let focusedElementBeforeProgramAgreementModal; // element to return the focus on close of program agreement modal
export const FPTI_PAYMENT_SECURITY_PAGE_NAME = 'payment_security';
export class PaymentSecurityPage extends Component {
    static propTypes = {
        onCloseModal: PropTypes.func,
        showAsModal: PropTypes.bool,
        onClickPurchase: PropTypes.func.isRequired,
        onClickDecline: PropTypes.func.isRequired,
        onCheckReadAgreement: PropTypes.func.isRequired,
        onToggleProgramAgreement: PropTypes.func.isRequired,
        onClickCancel: PropTypes.func.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        submitting: PropTypes.bool,
        submitSucceeded: PropTypes.bool,
        onFormSubmit: PropTypes.func.isRequired,
        submitFailed: PropTypes.bool,
        formValues: PropTypes.object,
        onComponentDidMount: PropTypes.func.isRequired,
        flow: PropTypes.string.isRequired,
        onChooseRadioOption: PropTypes.func.isRequired,
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    state = {
        isPaymentSecurityAgreementVisible: false
    }

    componentDidMount() {
        this.props.onComponentDidMount(this.props);
        if (this.props.showAsModal) {
            // Handle the focus manually because we are opening a modal "over" another modal
            // start the focus on the close button for the payment security modal
            const closeModalElement = document.querySelector('#PaymentSecurityPopup #close-popup');
            closeModalElement && closeModalElement.focus();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { showAsModal } = this.props;
        const { isPaymentSecurityAgreementVisible } = this.state;
        const closeModalElement = document.querySelector('#PaymentSecurityPopup #close-popup');

        if (showAsModal && isPaymentSecurityAgreementVisible === false && prevState.isPaymentSecurityAgreementVisible === true) {
            // set the focus to the element that was focused before opening the program agreement
            focusedElementBeforeProgramAgreementModal && focusedElementBeforeProgramAgreementModal.focus();
        }
        if (showAsModal && isPaymentSecurityAgreementVisible === true && prevState.isPaymentSecurityAgreementVisible === false) {
            // set the focus to the close button when opening the program agreement
            closeModalElement && closeModalElement.focus();
        }
    }

    handleCancelApplication = event => {
        this.props.onClickCancel(event);
    };

    handleChooseRadioOption = event => {
        const option = event?.target?.value;
        this.props.onChooseRadioOption(option);
    }

    handlePageSubmitTracking = () => {
        const choice = _.get(this.props.formValues, PAYMENT_SECURITY_CHOICE_RADIO_KEY);
        const { onClickPurchase, onClickDecline } = this.props;
        if (choice === DO_NOT_PURCHASE_PYMT_SECURITY) {
            onClickDecline();
        } else {
            onClickPurchase();
        }
    }

    getHeader() {
        const flow = this.props.flow;
        const defaultHeader = (
            <Header
                onCancel={this.handleCancelApplication} singleColumnLayout={false}
            />
        );
        if (flow !== FLOW_TYPE.TESLA && flow !== FLOW_TYPE.VENICE) {
            return defaultHeader;
        }
        return '';
    }

    openPaymentSecurityProgramAgreement = () => {
        if (this.props.showAsModal) {
            // Handle the focus manually because we are opening a modal "over" another modal
            // save the current element on the payment security modal that is focused
            focusedElementBeforeProgramAgreementModal = document.getElementById('payment-security-agreement-checkbox');

        }
        // Set the overflow on the body to hidden so there are not double scrollbars
        document.body.classList.add('disable-scroll');
        this.setState({
            isPaymentSecurityAgreementVisible: true,
        });
        this.props.onToggleProgramAgreement({ open: true });
    }

    closePaymentSecurityProgramAgreement = () => {
        // Set the overflow on the body to auto so the body will scroll
        document.body.classList.remove('disable-scroll');
        this.setState({
            isPaymentSecurityAgreementVisible: false,
        });
        this.props.onToggleProgramAgreement({ open: false });
    }

    render() {
        const {
            onCloseModal,
            showAsModal = true,
            onClickPurchase,
            onClickDecline,
            handleSubmit,
            submitFailed,
            onFormSubmit,
            formValues,
            flow
        } = this.props;

        const { isPaymentSecurityAgreementVisible } = this.state;

        const showPaymentSecurityAgreement = () => isPaymentSecurityAgreementVisible;

        const showMustChooseError = !showAsModal && submitFailed && _.isNil(_.get(formValues, PAYMENT_SECURITY_CHOICE_RADIO_KEY));

        const getButtonText = () => {
            const choice = _.get(formValues, PAYMENT_SECURITY_CHOICE_RADIO_KEY);
            if (choice === PURCHASE_PYMT_SECURITY) {
                return 'Purchase Payment Security';
            } else if (choice === DO_NOT_PURCHASE_PYMT_SECURITY) {
                return 'Continue without Payment Security';
            } else {
                return 'Continue';
            }
        };

        const sheetFooter = (
            <div id="action-buttons" className="actionButtons">
                <div className="userAgreement">
                    <Field
                        id="agreeToPymtSecurity"
                        className="agreeToPymtSecurity"
                        name="agreeToPymtSecurity"
                        alignLabelTop={true}
                        alignErrorLeft={true}
                        showErrorOnSubmitFail={true}
                        label={
                            <span id="agreeToPymtSecurityLabel" className="agreementDisclosureText">
                                You have read and agree to the{' '}
                                <Button
                                    className="agreementButtonCheckbox"
                                    name="paymentSecurityAgreement"
                                    btnType={BUTTON_TYPE.BUTTON}
                                    btnStyle={BUTTON_STYLE.LINK}
                                    data-automation-id="open-payment-security-agreement-checkbox"
                                    id="payment-security-agreement-checkbox"
                                    onClick={this.openPaymentSecurityProgramAgreement}
                                >
                                    Payment Security Program Agreement
                                </Button>
                                .
                            </span>
                        }
                        labelStyle={CHECKBOX_LABEL_STYLE.NORMAL}
                        component={CheckBox}
                        onChange={this.props.onCheckReadAgreement}
                    />
                </div>
                <div>
                    <Button
                        id="purchase-payment-security"
                        btnType={BUTTON_TYPE.SUBMIT}
                        data-automation-id="pps"
                        onClick={onClickPurchase}
                        btnStyle={BUTTON_STYLE.PP_PRIMARY}
                    >
                        Purchase Payment Security
                    </Button>
                </div>
                <div>
                    <Button
                        btnType={BUTTON_TYPE.BUTTON}
                        btnStyle={BUTTON_STYLE.LINK}
                        data-automation-id="skip-payment-security"
                        id="no-payment-security"
                        onClick={() => {
                            onClickDecline(true);
                            onCloseModal();
                        }}
                    >
                        Continue without Payment Security
                    </Button>
                </div>
            </div>
        );

        const pageFooter = (
            <div id="action-buttons" className="buttons">
                <div className="userAgreement">
                    <fieldset role="radiogroup" className={`ppvx_radio-group pymt-security-radio-group ${showMustChooseError ? 'ppvx_field--error' : ''}`} >
                        <legend className="ppvx_radio-group__label action-legend">Do you want to purchase Payment Security?</legend>
                        <Field 
                            id="pymt-security-purchase"
                            key="pymt-security-purchase"
                            name={PAYMENT_SECURITY_CHOICE_RADIO_KEY}
                            radioLabel={
                                <span className="agreementDisclosureText">
                                    Yes, I want to purchase optional Payment Security. I have read and agree to the{' '}
                                    <Button
                                        className="agreementButtonRadio"
                                        name="paymentSecurityAgreement"
                                        btnType={BUTTON_TYPE.BUTTON}
                                        btnStyle={BUTTON_STYLE.LINK}
                                        data-automation-id="open-payment-security-agreement-radio"
                                        id="payment-security-agreement-radio"
                                        onClick={this.openPaymentSecurityProgramAgreement}
                                    >
                                        Payment Security Program Agreement
                                    </Button>.
                                </span>
                            }
                            component={RadioInput}
                            type="radio" 
                            radioValue={PURCHASE_PYMT_SECURITY}
                            radioChoice={_.get(formValues, PAYMENT_SECURITY_CHOICE_RADIO_KEY)}
                            onBlur={(event) => {
                                event.preventDefault();
                            }}
                            onChange={this.handleChooseRadioOption}
                        />
                        <Field 
                            id="pymt-security-no-purchase" 
                            key="pymt-security-no-purchase"
                            name={PAYMENT_SECURITY_CHOICE_RADIO_KEY}
                            radioLabel={'No, continue without Payment Security.'}
                            component={RadioInput}
                            type="radio" 
                            radioValue={DO_NOT_PURCHASE_PYMT_SECURITY}
                            radioChoice={_.get(formValues, PAYMENT_SECURITY_CHOICE_RADIO_KEY)}
                            onBlur={(event) => {
                                event.preventDefault();
                            }}
                            onChange={this.handleChooseRadioOption}
                        />
                        {showMustChooseError && 
                            <div id="radio_error-message" className="ppvx_radio-group__error-text">
                                Choose an option to continue.
                            </div>
                        }
                    </fieldset>
                </div>
                <div>
                    <Button
                        btnType={BUTTON_TYPE.SUBMIT}
                        btnStyle={BUTTON_STYLE.PP_PRIMARY}
                        data-automation-id="continue-payment-security-page"
                        id="continue-payment-security-page"
                        onClick={this.handlePageSubmitTracking}
                    >
                        {getButtonText()}
                    </Button>
                    <CancelUrl
                        id="cancel-app-pymt-sec"
                        componentType={COMPONENT_STYLE.LINK_BUTTON}
                        fptiEvent={{
                            stateName: FPTI_PAYMENT_SECURITY_PAGE_NAME,
                            transitionName: 'cancel_apply_pp_credit_paymentsecuritypage'
                        }}
                    />
                </div>
            </div>
        );

        const innerContent = (
            <>
                <div className="header-illustration">
                    <UmbrellaIllustration />
                </div>
                <h1 className="payment-security-header header-text" data-initialfocus>Want to add Payment Security?</h1>
                <p className="header-sub-text">(Optional)</p>
                <div className="content">
                    <p className="content-text">
                        It can cover your minimum payments or entire PayPal Credit balance up to $10,000 after certain life events.
                    </p>
                    <p className="content-text">
                        It’s optional, and you can cancel anytime. If you cancel within 90
                        days, we’ll refund the fees you’ve paid so far.
                    </p>
                </div>
                <div className="content cost">
                    <h2 className="section-heading">What it costs</h2>
                    <p className="content-text">
                        $1.66 per $100 of your last statement balance. For example, if you
                        had a $500 balance, you’d pay $8.30.
                    </p>
                </div>
                <div className="eventLoss content">
                    <h2 className="section-heading">What qualifies as an event</h2>
                    <div>
                        <ul className="eventQualifiers">
                            <li> Unemployment </li>
                            <li> Leave of absence </li>
                            <li> Nursing home stay </li>
                            <li> Disability </li>
                            <li> Hospitalization </li>
                            <li> Loss of life </li>
                        </ul>
                    </div>
                    <p className="content-text">
                        You’re covered for most events right away, as long as they occur
                        after your sign-up date.
                    </p>
                    <p className="content-text">
                        For a job loss or leave of absence, coverage starts 30 days after
                        you sign up.
                    </p>
                </div>
                <div className="content cost">
                    <h2 className="section-heading">What to know</h2>
                    <ul>
                        <li className="content-bullet">
                            You authorize the program costs, calculated at $1.66 per $100 of
                            your last statement balance, to be billed to your PayPal
                            account each month, effective immediately.
                        </li>
                        <li className="content-bullet">
                            You may cancel anytime. If you cancel within 90 days, you’ll
                            receive a full refund.
                        </li>
                        <li className="content-bullet">
                            All events must begin after you enroll in the program; for a job
                            loss or leave of absence, you must have been enrolled for 30
                            days prior to occurrence.
                        </li>
                        <li className="content-bullet">
                            Job loss and leave of absence benefits depend on your job type:
                        </li>
                        <li className="hidden-bullet">
                            <ul>
                                <li className="content-bullet">
                                    You must have a full-time, year-round job to qualify for full
                                    balance cancellation.
                                </li>
                                <li className="content-bullet">
                                    Seasonal or part-time jobs only qualify for cancellation of up
                                    to 6 months of minimum payments.
                                </li>
                            </ul>
                        </li>
                        <li className="content-bullet">
                            You understand the program fee will appear on your statement
                            every month and will be charged even if you pay your statement
                            balance in full.
                        </li>
                        <li className="content-bullet">
                            Purchasing or declining this program won’t affect your credit
                            application or the terms of any credit agreements you have with
                            Synchrony Bank.
                        </li>
                        <li className="content-bullet">
                            Read the Program Agreement for full details about eligibility
                            requirements and exclusions that may affect your ability to
                            receive benefits.
                        </li>
                        <li className="content-bullet">
                            Payment Security isn’t available to Mississippi residents.
                        </li>
                    </ul>
                </div>
                {showAsModal ? sheetFooter : pageFooter}
            </>
        );

        const paymentSecurityForm = (
            <Form
                id="PaymentSecurityPageForm"
                onSubmit={handleSubmit(onFormSubmit)}
            >
                <section id="PaymentSecurityPage" className={`PaymentSecurityPage ${showPaymentSecurityAgreement() ? 'payment-security-program-agreement' : ''}`}>
                    {showAsModal && 
                        <AnnouncementPopup
                            id="PaymentSecurityPopup"

                            onClose={(event) => {
                                if (showPaymentSecurityAgreement()) {
                                    this.closePaymentSecurityProgramAgreement();
                                } else {
                                    onCloseModal(event);
                                }
                            }}
                            showXButton={true}
                            stickyFooter={false}
                            showPPLogo={false}
                        >
                            <div className={`${showPaymentSecurityAgreement() ? 'hide-section' : ''}`}>
                                {innerContent}
                            </div>
                            <div className={`${!showPaymentSecurityAgreement() ? 'hide-section' : ''}`}>
                                <PaymentSecurityProgramAgreementContent
                                    htmlUri={PAYMENT_SECURITY_PROGRAM_AGREEMENT_URL}
                                    iframeContainerQuerySelector="#PaymentSecurityPopup .announcement-popup-content"
                                />
                            </div>
                        </AnnouncementPopup>
                    }
                    {!showAsModal && 
                        innerContent
                    }
                </section>
            </Form>
        );

        return (
            <>
                {!showAsModal && 
                    <>
                        <div className="outerWrapper us-wrapper">
                            <div id="wrapper">
                                <div id="main" className="paymentSecurityPageLayout">
                                    <Header singleColumnLayout={true} />
                                    {paymentSecurityForm}
                                </div>
                            </div>
                            <Footer showCancelUrl={flow !== FLOW_TYPE.TESLA} />
                        </div>
                        {showPaymentSecurityAgreement() && 
                            <PaymentSecurityProgramAgreementModal 
                                onClose={this.closePaymentSecurityProgramAgreement}
                            />
                        }
                    </>
                }
                {showAsModal && paymentSecurityForm}
                
            </>
        );
    }
}

export const validate = (values, props) => {
    const errors = {};
    if (!props.showAsModal && !values.pymtSecurityChoice) {
        errors.pymtSecurityChoice = 'Required';
    }

    if (props.showAsModal && !values.agreeToPymtSecurity) {
        errors.agreeToPymtSecurity = {
            msg: 'Check the box to purchase Payment Security, or continue without Payment Security.',
            className: 'hasError'
        };
    }

    return errors;
};

export const onSubmitFail = (errors, dispatch) => {
    if (_.get(errors, READ_PROGRAM_AGREEMENT_CHECKBOX_KEY, null)) {
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, 'ppc_applctn_pmt_sec_chkbx_not_checked_to_purchase_shown'));
        // focus on the checkbox because it has an error
        const agreeProgramAgreementElement = document.getElementById('agreeToPymtSecurity');
        agreeProgramAgreementElement && agreeProgramAgreementElement.focus();
    }

    if (_.get(errors, PAYMENT_SECURITY_CHOICE_RADIO_KEY, null)) {
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, 'ppc_applctn_pmt_sec_radio_not_selected_shown'));
        // focus on the radio group because it has an error
        const optInElement = document.getElementById('pymt-security-purchase');
        optInElement && optInElement.focus();
    }
};

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount(props) {
        capeLog && capeLog('Loading payment security page');
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, 'prepare_payment_security'));
        if (_.isNil(props.paymentSecurityExperiment) || props.paymentSecurityExperiment === PYMT_SECURITY_CTRL) {
            capeLog && capeLog('PaymentSecurityPage: payment security experiment is in control or not present - redirecting to error page');
            dispatch(push(PAGE_NAME.ERROR_PAGE));
        }
    },
    onClickCancel() {
        dispatch(reset(PYMT_SECURITY_FORM_ID));
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, 'cancel_x_payment_security'));
    },
    onClickPurchase() {
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, 'pmt_sec_with_purchase_pressed'));
        dispatch(submit(PYMT_SECURITY_FORM_ID));
    },
    onClickDecline(resetForm = false) {
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, 'pmt_sec_without_purchase_pressed'));
        if (resetForm) {
            dispatch(reset(PYMT_SECURITY_FORM_ID));
        }
    },
    onChooseRadioOption(option) {
        const fptiOption = option === PURCHASE_PYMT_SECURITY ? 'purchase' : 'do_not_purchase';
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, `ppc_applctn_pmt_sec_option_${fptiOption}_radio_chosen`));
    },
    onCheckReadAgreement() {
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, 'ppc_applctn_pmt_sec_chkbox_pressed'));
    },
    onToggleProgramAgreement(visibleState) {
        const fptiVisibleState = visibleState.open ? 'open' : 'close';
        dispatch(trackTransition(FPTI_PAYMENT_SECURITY_PAGE_NAME, `ppc_applctn_pmt_sec_prog_agreement_${fptiVisibleState}`));
    },
    onFormSubmit(formValues) {
        dispatch(spinnerOpen());
        const submitData = {
            agreeToPymtSecurity: _.get(formValues, READ_PROGRAM_AGREEMENT_CHECKBOX_KEY)
        };
        const radioChoice = _.get(formValues, PAYMENT_SECURITY_CHOICE_RADIO_KEY);
        if (!_.isNil(radioChoice)) {
            submitData.agreeToPymtSecurity = radioChoice === PURCHASE_PYMT_SECURITY;
        }
        return dispatch(submitPaymentSecurity(submitData));
    }
});

const mapStateToProps = state => {
    const showAsModal = _.get(state, 'serverData.elmo.PaymentSecurity') === PYMT_SECURITY_CARD;
    return {
        flow: _.get(state, 'serverData.flow'),
        showAsModal,
        agreeToReadPymtSecurityChecked: formValueSelector(PYMT_SECURITY_FORM_ID)(state, READ_PROGRAM_AGREEMENT_CHECKBOX_KEY) === true,
        formValues: getFormValues(PYMT_SECURITY_FORM_ID)(state) || {},
        submitFailed: _.get(state, `form.${PYMT_SECURITY_FORM_ID}.submitFailed`),
        submitSucceeded: _.get(state, `form.${PYMT_SECURITY_FORM_ID}.submitSucceeded`),
        submitting: _.get(state, `form.${PYMT_SECURITY_FORM_ID}.submitting`),
        wholeForm: _.get(state, `form.${PYMT_SECURITY_FORM_ID}`),
        paymentSecurityExperiment: _.get(state, 'serverData.elmo.PaymentSecurity')
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(
    reduxForm({
        form: PYMT_SECURITY_FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true,
        validate,
        onSubmitFail,
        onSubmitSuccess: (result, dispatch, props) => {
            if (props.showAsModal) {
                props.onCloseModal();
            }
        }
    })(PaymentSecurityPage)
);